import { render, staticRenderFns } from "./DashboardVendasOnline.vue?vue&type=template&id=40e0cdbf&scoped=true"
import script from "./DashboardVendasOnline.vue?vue&type=script&lang=js"
export * from "./DashboardVendasOnline.vue?vue&type=script&lang=js"
import style0 from "./DashboardVendasOnline.vue?vue&type=style&index=0&id=40e0cdbf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40e0cdbf",
  null
  
)

export default component.exports